import {Injectable} from '@angular/core'
import {HttpClient, HttpErrorResponse} from '@angular/common/http'
import {LoggerService} from '@app/core/services/logger.service'
import {tap} from 'rxjs/operators'
import {LogRecord} from '@app/core/services/logrecord/logrecord.interface'
import {Observable} from 'rxjs'

@Injectable()
export class LogRecordService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getLogRecords(terminalId: number): Observable<LogRecord[]> {
    const url = `api://Terminals/${terminalId}/log`
    return this.http.get<LogRecord[]>(url).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public postLogRequest(
    terminalId: number,
    logRecord: LogRecord,
  ): Observable<LogRecord> {
    const url = `api://Terminals/${terminalId}/log`
    return this.http.post<LogRecord>(url, logRecord).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  public getLogRecordContent(terminalId: number, logRecordId: number) {
    const url = `api://Terminals/${terminalId}/log/${logRecordId}`
    return this.http.get(url, {responseType: 'arraybuffer'}).pipe(
      tap(
        (res) => {
          this.logger.log(res)
        },
        (err: Error) => {
          this.handleError(err)
        },
      ),
    )
  }

  private handleError(err: Error) {
    if (err instanceof HttpErrorResponse) {
      if (err.error && err.error.description) {
        throw new Error(err.error.description)
      } else {
        throw new Error('Error: ' + err.status + ' => ' + err.message)
      }
    }
  }
}
